/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { NationwideProjectsControllerService } from './services/nationwide-projects-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    NationwideProjectsControllerService,
    ApiConfiguration
  ],
})
export class CustomersProjectModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersProjectModule> {
    return {
      ngModule: CustomersProjectModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersProjectModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersProjectModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
